import { createMarkup } from "@via/utils/html-utils.tsx";
import "easymde/dist/easymde.min.css";
import { type JSX, useCallback, useMemo } from "react";
import SimpleMdeReact, {
  type SimpleMDEReactProps,
} from "react-simplemde-editor";
import "./markdown-editor.css";

const INITIAL_MESSAGE = "Begin typing to create your description...";
export default function MarkdownEditor({
  value,
  onChange,
  isEditing,
  maxHeight = "700px",
}): JSX.Element {
  const defaults = useMemo(() => {
    return {
      spellChecker: false,
      maxHeight: maxHeight,
      sideBySideFullscreen: false,
      placeholder: INITIAL_MESSAGE,
      status: false,
      lineNumbers: false,
      renderingConfig: {
        codeSyntaxHighlighting: true,
        sanitizerFunction: (renderedHTML: string) => {
          const markup = createMarkup(renderedHTML);
          return markup.__html;
        },
      },
    };
  }, []) as SimpleMDEReactProps;

  const handleToggleEdit = useCallback(
    (instance): void => {
      instance.togglePreview();
    },
    [isEditing]
  );

  return (
    <div className="markdown-editor-wrap prose max-w-none">
      <SimpleMdeReact
        options={defaults}
        value={value}
        onChange={onChange}
        getMdeInstance={handleToggleEdit}
      />
    </div>
  );
}
